import React from 'react';
import { useQuery } from 'react-query';
import { fetchProfiles } from '../api/services';

const fetchProfilesData = async () => {
    const response = await fetchProfiles();
    return response.data;
};

const ProfilesComponent = () => {
    const { data: profiles, isLoading, error } = useQuery('profiles', fetchProfilesData);

    if (isLoading) return <div style={{ color: 'white' }}>Loading...</div>;
    if (error) return <div style={{ color: 'white' }}>Error: {error.message}</div>;

    return (
        <div className="section">
            <h2>Josh Lee<br />Software Engineer</h2>
            {profiles?.map(profile => (
                <div key={profile.id} className="profile-entry">
                    <div className="profile-image-container">
                        <img 
                            src={profile.profile_picture_url} 
                            alt={`${profile.name}'s profile`} 
                        />
                    </div>
                    <div className="profile-info">
                        <h3>{profile.name}</h3>
                        <p><strong>Title:</strong><br /> {profile.title}</p>
                        <p><strong>Bio:</strong><br /> {profile.bio}</p>
                        <p><strong>Email:</strong><br /> {profile.contact_email}</p>
                        <p><strong>Phone:</strong><br /> ({profile.phone_number.substring(0,3)}) {profile.phone_number.substring(3, 6)}-{profile.phone_number.substring(6, 10)}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProfilesComponent;
